export class UserExistsForDifferentProviderError extends Error {
  constructor(public provider: string, public email: string) {
    super(`User with email "${email}" already exists for provider "${provider}"`);
  }
}
